import commonService from 'utils/commonService';
import apiService from 'bff/services/apiService';
import { BaseRes } from 'bff/models/base/baseRes';
import { Inscats } from 'bff/models/info';
import { ReturnCode } from 'constants/enums/returnCode.enum';

/**
 * @description 取得險種清單
*/
const fetchInscats = async () => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const res = await apiService.fetchInscat(baseReq, reqConfig).then((res:BaseRes<Inscats>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return commonService.arrayTypeReturn(res.TRANRS.INSURANCE_CATEGORY);
  }
};

export default {
  fetchInscats
};
